import { render, staticRenderFns } from "./VerificationConfirmation.vue?vue&type=template&id=5111e5b8"
import script from "./VerificationConfirmation.vue?vue&type=script&lang=js"
export * from "./VerificationConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports